import { BaseEntity, type Searchable } from './base'
import type { PermissionName } from './permissions'
import type { Role } from './role'

export class User extends BaseEntity implements Searchable {
  displayName!: string
  email!: string
  roles?: Role[]
  disabledAt!: string | null

  get searchString() {
    return [this.id, this.displayName, this.email].join(' ')
  }

  get disabled(): boolean {
    return !!this.disabledAt
  }
}

class GetUserBase {
  user!: User
}

export class GetMyUser extends GetUserBase {
  userPermissions!: PermissionName[]
}

export interface GetAllUsers {
  users: User[]
}

export class NewUser {
  displayName!: string
  email!: string
  firstLoginPassword!: string
  roleIds?: string[]
}

export class UpdateUser {
  displayName?: string
  email?: string
  roleIds?: string[]
  newPassword?: string
  disabledAt?: string | null
}

export class UserCreated extends GetUserBase {}
export class GetUserById extends GetUserBase {}
export class UserUpdated extends GetUserBase {}
